export default __webpack_public_path__ + "static/media/error.464df779.svg";